import { createContext, useContext, useState, useCallback, ReactNode } from 'react';

export interface SyncStatusState {
  lastSyncDate: Date | null;
  isConnected: boolean;
}

const defaultState: SyncStatusState = {
  lastSyncDate: null,
  isConnected: false,
};

const SyncStatusContext = createContext<{
  state: SyncStatusState;
  setConnected: (connected: boolean) => void;
  setLastSyncDate: (date: Date | null) => void;
}>({
  state: defaultState,
  setConnected: () => {},
  setLastSyncDate: () => {},
});

export function SyncStatusProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SyncStatusState>(defaultState);
  const setConnected = useCallback((connected: boolean) => {
    setState((prev) => (prev.isConnected === connected ? prev : { ...prev, isConnected: connected }));
  }, []);
  const setLastSyncDate = useCallback((date: Date | null) => {
    setState((prev) => {
      if (prev.lastSyncDate?.getTime() === date?.getTime()) return prev;
      return { ...prev, lastSyncDate: date };
    });
  }, []);
  return (
    <SyncStatusContext.Provider value={{ state, setConnected, setLastSyncDate }}>
      {children}
    </SyncStatusContext.Provider>
  );
}

export function useSyncStatus() {
  return useContext(SyncStatusContext);
}
